import { Outlet } from "react-router-dom";
export default function PublicLayout() {
  return (
    <div className="min-h-dvh grid place-items-center p-6 bg-gradient-to-b from-[#d6e6ff] to-[#e8eaee]">
      <Outlet />
    </div>
  );
}
